import React, {lazy} from 'react';

export const components = {
    NewsArchive: lazy(() => import("./components/NewsArchive/NewsArchive")),
    MediaArticle: lazy(() => import("./components/MediaArticle/MediaArticle"))
}

export default components;
